import {UserOrGroupModel} from './UserOrGroup.model';

export class  AccessLogModel {
  public accessLogId: number;
  public roleId: number;
  public userOrGroupId: number;
  public viewAt: Date;
  public roleName: string;
  public userOrGroup: UserOrGroupModel;

  constructor() {
  }
}

export interface DALAccesLogModel {

        Id :number;

        RoleId: number;

        UserOrGroupId: number;

        ViewAt: Date;
}

